(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Détection automatique du chargement sur results-list
  document.addEventListener('DOMContentLoaded', () => {
    const resultsList = document.querySelector('results-list');
    const loader = document.getElementById('infinite-scroll-loader');

    if (resultsList && loader) {
      const observer = new MutationObserver(() => {
        const isLoading = 
          resultsList.hasAttribute('loading') || 
          resultsList.getAttribute('aria-busy') === 'true' ||
          resultsList.classList.contains('is-loading');

        loader.style.display = isLoading ? 'flex' : 'none';
      });

      observer.observe(resultsList, { 
        attributes: true, 
        attributeFilter: ['loading', 'aria-busy', 'class'] 
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
